export const rvDetailsDefaultGroupingFields = ['group1']
export const rvDetailsDateFilterFields = ['maturity_date']

export const rvSecurityDetailsDefaultColumnsFieldsToVisible = [
  'group1',
  'security_id',
  'portsec_holdings',
  'description',
  'coupon',
  'maturity_date',
  'portsec_price',
  'portsec_invest_weight',
  'portsec_base_return',
  'portsec_currency_return',
  'portsec_contribution',
  'allocation_low2',
  'selection_effect2',
]

export const rvSecurityDetailsTopAndBottom5FieldsToVisible = [
  'security_id',
  'description',
  'portsec_notional_mktval',
  'portsec_invest_weight',
  'portsec_contribution',
]

export const rvSecurityDetailsFieldsToHide = [
  'report_id',
  'begin_date',
  'end_date',
]
export const rvColumnFieldForTableChartLinkingValue = ['portsec_invest_weight']
export const rvTopAndBottomFiveSecuritiesFilterKey = 'portsec_currency_return'
